export default "__VITE_ASSET__mkOTtYUN__"